import { render } from "./loading.vue?vue&type=template&id=4b2c8277&scoped=true&ts=true"
import script from "./loading.vue?vue&type=script&lang=ts"
export * from "./loading.vue?vue&type=script&lang=ts"

import "./loading.vue?vue&type=style&index=0&id=4b2c8277&scoped=true&lang=less"

import exportComponent from "/Users/user/Projects/simweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2c8277"]])

export default __exports__